<template>
  <div class="container">
    <div class="content" v-if="this.data">
      <!-- This code creates a div that displays information about a booking -->
      <div class="title">
        <div class="info">
          <!-- This line displays the passenger's full name -->
          <p class="order-id">
            <span class="material-icons middle">person</span>
            <span class="middle" v-if=" data.origin !== 'phone'">
              {{ data.passenger_name }}
            </span>
            <span class="middle" v-else>
              {{ data.meta_passenger_name }}
            </span>
            <!-- This line displays the booking ID -->
            <span :style="{
              color: data.high_priority == 1 ? 'rgb(239 194 11)' : '#e10015',
              fontWeight: 'bold',
              border: data.high_priority == 1 ? '1px solid rgb(239 194 11)' : '1px solid #e10015',
              padding: '3px'
            }">{{ data.id }}</span>

            <!-- This line displays a mobile icon if the booking from customer app -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-if="data.origin === 'app'">
              <v-icon style="color: #27a432"> fa fa-mobile </v-icon>
            </span>
            <!-- This line displays a laptop icon sif the booking from call center -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-else-if="data.origin === 'dashboard'">
              <v-icon style="color: #27a432"> fa fa-laptop </v-icon>
            </span>
            <!-- This line displays a phone icon if the booking from customer dashboard -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-else-if="data.origin === 'phone'">
              <v-icon style="color: #27a432"> fa fa-phone </v-icon>
            </span>
          </p>
          <p class="datetime" v-if="data.passenger_username && data.origin !== 'phone'">
            <span class="material-icons middle">local_phone</span>
            <span>
              {{
                data.passenger_username
              }}</span>
          </p>

          <p class="datetime" v-if="data.meta_passenger_phone_number && data.origin == 'phone'">
            <span class="material-icons middle">local_phone</span>
            <span>
              {{
                data.meta_passenger_phone_number
              }}</span>
          </p>

        </div>
      </div>

      <p v-if="data.status === 'PAID'" style="color: green"><b>Completed</b></p>
      <p v-else-if="data.status === 'PASSENGER_CANCELLED'" style="color: red">
        <b>Cancelled by customer</b>
      </p>
      <p v-else-if="data.status === 'CAPTAIN_CANCELLED'" style="color: red">
        <b>Cancelled by driver</b>
      </p>
      <p v-else-if="data.status === 'SYSTEM_CANCELLED'" style="color: red">
        <b>Cancelled by system</b>
      </p>
      <p v-else-if="data.status === 'CC_CANCELLED'" style="color: red">
        <b>Cancelled by CC</b>
      </p>
      <p v-else-if="show_status">
        {{ this.orderStatuses[data.status] }}
      </p>


      <div class="locations">
        <div class="location">
          <div class="circle" style="background-color: #fff"></div>
          <label class="location">
            <label style="color: #00abb3">{{ data.pickup_name }}, </label>

          </label>
        </div>
        <div class="location">
          <div class="circle"></div>
          <label>{{ data.dropdown_name }}</label>
        </div>
      </div>

      <p class="datetime" v-if="(data.service_name)">
        <span class="material-icons middle">miscellaneous_services</span>
        <span class="middle">{{ data.service_name }}</span>

      </p>

      <p class="datetime" v-if="data.price">
        <span class="material-icons middle">attach_money</span>
        <span class="middle">{{ formatPrice(data.price) }}</span>
      </p>

      <p class="datetime" v-if="data.estimated_price">
        <span class="material-icons middle">attach_money</span>
        <span class="middle">
          Estimated: {{ formatPrice(data.estimated_price) }}
        </span>
      </p>

      <p class="datetime" v-if="data.rate_order !== null && data.rate_order !== undefined">
        <span class="material-icons middle">star</span>
        <span class="middle" style="display: inline-flex; align-items: center; gap: 1px;">
          <span 
            v-for="n in 5" 
            :key="n"
            class="material-icons"
            :style="{ 
              color: n <= data.rate_order ? '#f3c220' : (n - 0.5 <= data.rate_order ? '#f3c220' : '#e0e0e0'),
              fontSize: '18px',
              opacity: n <= data.rate_order ? '1' : (n - 0.5 <= data.rate_order ? '0.5' : '0.3')
            }"
          >
            {{ n <= data.rate_order ? 'star' : (n - 0.5 <= data.rate_order ? 'star_half' : 'star_border') }}
          </span>
        </span>
      </p>

      <p class="datetime" v-if="(data.car_brand_name)">
        <span class="material-icons middle">directions_car</span>
        <span class="middle" v-if="data.car_brand_model && data.car_brand_name"> {{ data.car_brand_name }} ,
          {{ data.car_brand_model }}, {{ data.car_color }}</span>

      </p>
      <div v-if="
        data.taxi_number
      " class="w-full float-left">
        <div class="driver">
          <div class="captain-profile-pic">
            0<span v-if="data.taxi_number">{{ data.taxi_number }}</span>
          </div>
          <label>

            <span class="material-icons middle" v-if="data.captain_first_name">person_pin</span>
            <span class="middle" v-if="data.captain_first_name">{{ data.captain_first_name }}</span>

          </label>
        </div>
      </div>
      <p class="datetime" v-if="(data.car_plate_number)">
        <span class="material-icons middle">credit_card</span>
        <span class="middle">{{ data.car_plate_number }}</span>
      </p>






      <p class="datetime">
        <span class="material-icons middle">schedule</span>
        <span class="middle">{{ formateDateTime(data.created_at) }}</span>
      </p>


      <p class="datetime" v-if="!data.now">
        <span class="material-icons middle">departure_board</span>
        <span class="middle">{{ formateDateTime(data.datetime) }}</span>
      </p>

      <div v-if="actions && !hideActions" class="actions-container">
        <div class="actions">
          <button v-for="(action, index) in actions" :key="index">
            <img :src="require(`@/assets/actions/${action.img}`)" @click="handleFunctionCall(action.method)"
              :title="action.hint" />
          </button>


        </div>
      </div>
    </div>
    <div v-else>Loading</div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Choose a captain to assign the booking for </span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="returnObject" clearable :items="captains" :loading="isLoading"
            :search-input.sync="search" outline dense label="Captain" item-text="text" item-value="text"
            placeholder="Search for a captain" no-filter return-object>
            <template slot="item" slot-scope="captains">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="captains.item.first_name + ' ' + captains.item.last_name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialog = false">Close</v-btn>
          <v-btn color="primary" :loading="loading" flat @click="manualDispatch">Dispatch</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancellationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Cancellation reason: </span>
        </v-card-title>
        <v-card-text>
          <div v-for="option in userCancellationReasons" :key="option.id" class="radio-option">
            <input type="radio" :value="option.id" v-model="returnUserCancellationReason" :id="option.id"
              class="radio-input" />
            <label :for="option.id" class="radio-label">{{ option.text_en }}</label>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancellationDialog = false">Close</v-btn>
          <v-btn color="primary" :loading="loading" flat @click="submitCancelOrder">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { formatCompanyTime, toCompanyMoment, companyNow } from "@/util/companyTime";
import api from "@/constants/api.js";
let CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "OrderCard",
  props: {
    data: {
      type: Object,
      required: false,
    },
    id: {
      type: Number,
      required: false,
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: false,
    },

    show_status: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userCancellationReasons: [],
      constraints: [],
      actions: [],

      edit: 0,
      pickup: "Malki",
      destination: "Damascus",
      loading: false,
      showPastTime: true,
      date: "",
      test: "",
      diff: "",
      red: false,
      dialog: false,
      cancellationDialog: false,
      returnObject: null,
      returnUserCancellationReason: "",
      isLoading: false,
      search: null,
      captains: [],
      currencyFormatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "SYP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      orderStatuses: {
        PENDING: "Waiting for dispatching",
        ACCEPTED: "Order dispatched",
        STARTED: "Driver is on the way",
        ARRIVED: "Arrived to pickup",
        PICKED_UP: "Trip started",
        DONE: "Arrived to dropoff",
        PAID: "Successful",
        CAPTAIN_CANCELLED: "Cancelled by driver ",
        PASSENGER_CANCELLED: "Cancelled by customer",
        SYSTEM_CANCELLED: "Cancelled by system",
        CC_CANCELLED: "Cancelled by CC",
      },
      formatters: {
        // Final-version doc 2026-10-05: Damascus time, whatever the PC zone.
        datetime(value) {
          return formatCompanyTime(value, "HH[h]m - DD/MM/YYYY");
        },
        created_at(value) {
          return formatCompanyTime(value, "HH[h]m - DD/MM/YYYY");
        },
      },
      currencyFormatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "SYP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    };
  },

  computed: {
    time: function () {
      return moment(this.date);
    },
  },
  watch: {
    diff() {
      this.test = this.diff;
      if (this.diff < 600) {
        this.red = true;
      }
    },

    search(val) {
      this.isLoading = true;
      if (cancel) cancel();
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get("captain/search", {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.captains = res.data.data.map((item) => ({
            text: `${item.full_name || ""}` + " " + `${item.username || ""}`,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.isLoading = false));
    },
  },
  mounted: function () {
    if (this.diff)
      setInterval(() => {
        this.diff--;
      }, 1000);
  },
  created() {
    if (this.data) {

      this.showPastTime = ["PENDING", "ACCEPTED"].includes(this.data.status);



      // Details icon (was commented out before)
      if (this.$route && this.$route.name !== "Bookings") {
        this.actions.push({
          img: "openMap.svg",
          hint: "Open details",
          method: "openDetails",
        });
      }
      if (
        ["PENDING", "ACCEPTED", "STARTED", "ARRIVED"].includes(
          this.data.status
        )
      ) {
        this.actions.push({
          img: "cancel.svg",
          hint: "Click to cancel the order",
          method: "cancelOrder",
        });
      }

      if (this.data.status == "PENDING") {
        this.actions.push({
          img: "dispatch.svg",
          hint: "Click to manualy dispatch an order",
          method: "dispatchPopup",
        });

      }

      this.actions.push({
            img: "info.svg",
            hint: "Click to view order logs",
            method: "orderLogs",
          });


    }
  },
  methods: {
    formatPrice(value) {
      if (value == null) return "";
      // Redenominated display: stored old-unit value / 100, 2 decimals (via the
      // global money mixin). Stored/gateway values stay in the old unit.
      return this.formatMoney(value) + " SYP";
    },
    validateEmail(email) {
      let res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return res.test(email);
    },
    sendPendingReminder() {
      // Server times are Damascus wall clock; compare instants, not PC time.
      const orderDate = toCompanyMoment(this.data.created_at);
      const dateMinus15Minutes = companyNow().subtract(15, "minutes");
      if (orderDate && orderDate.isAfter(dateMinus15Minutes)) {
        window.getApp.$emit("SHOW_TOAST", "You can't send a reminder for orders waiting for dispatching since less than 15 minutes", "red");
        return;
      }


      this.$dialova({
        title: `Send Reminder`,
        paragraph: `Are you sure to send a reminder to drivers ?`,
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`send_pending_reminder`, { booking_id: this.data.id })
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                `Reminder sent`,
                "green"
              );

              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message || "Error Occurrd", "red");
              close();
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    sendDispatchedReminder() {
      const orderDate = toCompanyMoment(this.data.datetime);
      if (orderDate && orderDate.isAfter(companyNow())) {
        window.getApp.$emit("SHOW_TOAST", "You can't send a reminder for dispatched orders before the order time", "red");
        return;
      }


      this.$dialova({
        title: `Send Reminder`,
        paragraph: `Are you sure to send a reminder to the driver ?`,
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .post(`send_dispatched_reminder`, { booking_id: this.data.id })
            .then(() => {
              window.getApp.$emit(
                "SHOW_TOAST",
                `Reminder sent`,
                "green"
              );

              close();
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message || "Error Occurrd", "red");
              close();
            });
        })
        .catch(() => {
          console.log("cancelled");
        });
    },
    editorder() {
      this.edit = 1;
      const routeData = this.$router.resolve({
        name: "PhoneBooking",
        query: {
          show_order_list: false,
          id: this.data.id,
          grouper: this.data.group_order,
          // date: this.data.datetime,
          edit: 1,
        },
      });
      window.open(routeData.href, "_blank");
    },
    dispatchPopup() {
      this.dialog = true;
    },
    goToChat() {
      this.$router.push('/messages?conversation=' + this.data.ride.captain.conversation_id);
    },
    manualDispatch() {
      if (!this.returnObject)
        return;
      this.loading = true;
      this.axios
        .put(`dispatch/${this.data.id}/${this.returnObject.id}`)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            `Order #${this.data.id} has been successfully dispatched`,
            "green"
          );

          this.dialog = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    orderLogs() {
      this.$router.push({
        name: "BookingLog",
        params: { id: this.data.id },
      });
    },
    openMap() {
      this.$router.push({
        name: "Details",
        params: {
          data: JSON.stringify(this.data),
          id: this.data.id,
        },
      });
    },
    handleFunctionCall(func) {
      this[func]();
    },
    formateDateTime(time) {
      return formatCompanyTime(time, " DD[/]MM[/]YYYY HH:m", "");
    },
    pastTime(time) {
      moment.locale("fr");
      const at = toCompanyMoment(time);
      return at ? at.fromNow() : "";
    },
    cancelOrder() {
      this.$store
        .dispatch("getUserCancellationReasons")
        .then((data) => {
          this.userCancellationReasons = data;
          this.cancellationDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
      // this.$dialova({
      //   title: `Cancel order #${this.data.id}`,
      //   paragraph: `Are you sure you want to cancel <b>order #${this.data.id
      //     }</b> for passenger <b>${this.data.passenger && this.data.passenger.full_name
      //       ? this.data.passenger.full_name
      //       : ""
      //     }</b>${this.data.captain_name
      //       ? "that is dispatched with " + this.data.captain_name
      //       : ". order is not dispatched yet."
      //     }`,
      //   loader: true,
      // }).then(({ close }) => {
      //   axios
      //     .delete(api.ACTIONS.BOOKINGS + `/${this.data.id}`)
      //     .then(() => {
      //       window.getApp.$emit(
      //         "SHOW_TOAST",
      //         `Order #${this.data.id} has been cancelled`,
      //         "green"
      //       );
      //       console.log("emitted", this.data.id);
      //       this.$emit("cancelled", this.data.id);
      //     })
      //     .catch((err) => {
      //       window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
      //     })
      //     .finally(() => {
      //       close();
      //     });
      // });
    },
    submitCancelOrder() {
      if (!this.returnUserCancellationReason) {
        window.getApp.$emit("SHOW_TOAST", "Please choose a reason", "red");
        return;
      }
      this.loading = true;

      axios
        .delete(api.ACTIONS.BOOKINGS + `/${this.data.id}`, {
          params: {
            user_cancellation_reason_id: this.returnUserCancellationReason,
          },
        })
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            `Order #${this.data.id} has been cancelled`,
            "green"
          );
          console.log("emitted", this.data.id);
          this.$emit("cancelled", this.data.id);
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    stringToColour(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
      return colour;
    },
    openDetails() {
      // Go to /rides/:id (RidePage details)
      if (!this.data || !this.data.id) return;
      this.$router.push({ name: "Bookings", params: { id: this.data.id } });
    },
    rescheduleOrder() {
      this.$dialova({
        title: `Change time of order #${this.data.id}`,
        paragraph: `Please select the new time for booking #<b>${this.data.id}
        </b>, Passenger <b>${this.data.passenger.full_name}</b>
        </b> from <b>${this.data.pick_up_location_details}</b>${this.data.pull_down_location_details
            ? ` to <b>${this.data.pull_down_location_details}</b>`
            : ` to <b>${this.data.pull_down_location_name}</b>`
          } at <b>${this.formateDateTime(this.data.datetime)}</b>.`,
        loader: true,
        input: "Enter new datetime",
        type: "datetime-local",
      }).then(({ close, value }) => {
        axios
          .put(`booking/${this.data.id}`, {
            datetime: `${moment(value).format("YYYY-MM-DD HH:mm")}`,
          })
          .then((res) => {
            window.getApp.$emit(
              "SHOW_TOAST",
              `Booking #${this.data.id} time has been changed from ${this.formateDateTime(
                this.data.datetime
              )} to ${this.formateDateTime(value)}.`,
              "green"
            );
            this.data.datetime = res.data.data.datetime;
          })
          .catch((err) => {
            console.log("ERROR");
            console.log(err.response);
            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          })
          .finally(() => {
            close();
          });
        console.log(value);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.timer {
  color: red;
  font-weight: bold;
}

.strike_through {
  text-decoration-line: line-through
}

.radio-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.radio-option {
  padding-left: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-family: 'Poppins';
}

.radio-input {
  margin-right: 10px;
  cursor: pointer;
  accent-color: #4caf50;
  /* Change color of the radio button in modern browsers */
}

.radio-label {
  font-size: 16px;
  cursor: pointer;
}

.container {
  /*w-full h-auto float-left rounded-lg bg-white px-5 py-4 shadow*/
  width: 100%;
  height: auto;
  float: left;
  margin: 0;
  border-radius: 8px;
  background: white;
  padding: 1rem 1.25rem;
  box-shadow: 0px 0px 6px rgba($color: #000000, $alpha: 0.08);

  &.priority-border {
    box-shadow: inset 0px 0px 0px 1px gold, 0px 0px 6px rgba($color: gold, $alpha: 0.08);
  }

  p {
    margin: 0px;
  }

  .content {
    /*w-full float-left flex flex-col gap-5 font-medium*/
    width: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    font-weight: 500;

    /*w-full float-left*/
    .title {
      width: 100%;
      float: left;
      line-height: auto !important;
      font-family: Poppins !important;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        float: left;
        color: #222629;
        background: transparent !important;
        font-size: 14px;
        font-weight: normal;
        width: 100%;
        position: relative;

        .order-id {
          // width: 100%;
          float: left;
          display: flex;
          flex-wrap: wrap;
          width: 80%;
          align-items: center;

          p {
            width: 100%;
            float: left;
          }

          span {
            margin: 0 2%;
          }
        }
      }

      .constraints {
        float: right;
        height: auto;
        display: flex;
        flex-direction: row;
        gap: 7px;

        img {
          float: right;
        }
      }
    }

    .locations {
      width: 100%;
      float: left;
      height: auto;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 12px;

      // w-full flex flex-row items-center
      .location {
        // width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        float: left;

        .circle {
          border-radius: 100%;
          width: 15px;
          min-width: 15px;
          height: 15px;
          min-height: 15px;
          float: left;
          background: #e10015;
          border: 3px solid #e10015;
        }

        label {
          margin-left: 4px;
          float: left;
          word-break: break-word;
        }
      }
    }

    /*w-full float-left text-sm text-gray*/
    .datetime {
      width: 100%;
      float: left;
      font-size: 14px;
      color: #788e98;
      font-weight: 400;
    }

    // w-full float-left flex flex-row items-center gap-2
    .driver {
      width: 100%;
      float: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.4rem;

      .captain-profile-pic {
        max-height: 24px;
        padding: 2px 8px;
        background-color: #e1e1e1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 99px;
      }


      // rounded-full overflow-hidden img-shadow
      img {
        border-radius: 100%;
        overflow: hidden;
      }
    }

    // w-full float-left
    .actions-container {
      width: 100%;
      float: left;

      // w-full float-left mt-4 flex flex-row gap-2
      .actions {
        width: 100%;
        float: left;
        display: flex;
        flex-direction: row;
        gap: 0.5rem;

        button {
          max-height: 22px;
        }
      }
    }
  }
}

.middle {
  vertical-align: middle;
}
</style>
